<style scoped>
.pointer-cursor {
  cursor: pointer !important;
}
</style>

<template>
  <div>
    <checklist-legend :items="Object.values(statusMap)" />
    <v-divider />
    <anchor-data-table
      ref="table"
      hide-default-footer
      :items-per-page="-1"
      :item-key="itemKey"
      :sort-by="sortBy"
      :loading="loading"
      :headers="headers"
      :items="items"
      :item-class="rowClass"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </anchor-data-table>
  </div>
</template>

<script>
import ChecklistLegend from './ChecklistLegend';
import CHECKLIST_HEADERS from '../../../resources/js/checklist/headers';
import STATUS_MAP from '../../../resources/js/checklist/status-map';

export default {
  name: 'AnchorChecklistTable',
  components: {
    ChecklistLegend,
  },
  props: {
    items: Array,
    headers: {
      type: Array,
      default: () => CHECKLIST_HEADERS,
    },
    loading: Boolean,
    sortBy: {
      type: Array,
      default: () => (['title']),
    },
    itemKey: {
      type: String,
      default: 'category',
    },
    statusMap: {
      type: Object,
      default: () => STATUS_MAP,
    },
  },
  methods: {
    rowClass(item) {
      const status = this.statusMap[item.status];
      return status ? status.color : '';
    },
  },
};
</script>
